import { createContext, ReactNode, useState } from 'react'
import { PaymentSteps } from '../app/paymentSteps'
import { paymentStepSessionStorageKey } from '../app/storageKeys'

type PaymentStepContextType = [PaymentSteps, (newStep: PaymentSteps) => void]

const paymentSteps = Object.values(PaymentSteps)

const loadStepFromSessionStorage = () => {
  const stepFromSessionStorage = sessionStorage.getItem(
    paymentStepSessionStorageKey,
  )
  if (paymentSteps.includes(stepFromSessionStorage as PaymentSteps)) {
    return stepFromSessionStorage as PaymentSteps
  } else {
    return PaymentSteps.FILL_LICENSE_PLATE
  }
}

const saveStepToSessionStorage = (step: PaymentSteps) => {
  sessionStorage.setItem(paymentStepSessionStorageKey, step)
}

const defaultStep: PaymentSteps = loadStepFromSessionStorage()
export const PaymentStepContext = createContext<PaymentStepContextType>([
  defaultStep,
  () => {},
])

interface PaymentStepProviderProps {
  children: ReactNode
}

export const PaymentStepProvider = ({ children }: PaymentStepProviderProps) => {
  const [step, setStepState] = useState<PaymentSteps>(defaultStep)

  const setStep = (newStep: PaymentSteps) => {
    setStepState(newStep)
    saveStepToSessionStorage(newStep)
  }

  const value: PaymentStepContextType = [step, setStep]
  return (
    <PaymentStepContext.Provider value={value}>
      {children}
    </PaymentStepContext.Provider>
  )
}
